var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGallery(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "svg-icon",
    style: {
      width: "1em",
      height: "1em",
      verticalAlign: "middle",
      fill: "#797979",
      overflow: "hidden"
    },
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M736 224A96 96 0 0 1 832 320v384a96 96 0 0 1-96 96h-448A96 96 0 0 1 192 704V320a96 96 0 0 1 96-96z m0 64h-448A32 32 0 0 0 256 320v384a32 32 0 0 0 32 32h448a32 32 0 0 0 32-32V320a32 32 0 0 0-32-32z m-368 64a48 48 0 1 1 0 96 48 48 0 0 1 0-96z",
    fill: "#797979"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M757.184 755.328a32 32 0 0 1-45.248 0L508.416 551.68 304.64 755.328a32 32 0 1 1-45.248-45.248l225.856-225.792a32 32 0 0 1 45.696-0.448l226.24 226.24a32 32 0 0 1 0 45.248z",
    fill: "#797979"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGallery);
export default __webpack_public_path__ + "static/media/gallery.9b28d17ce8b24f13e109579817889808.svg";
export { ForwardRef as ReactComponent };